import { render, staticRenderFns } from "./NcbAgentsRemark.vue?vue&type=template&id=5517ac4a&scoped=true"
import script from "./NcbAgentsRemark.vue?vue&type=script&lang=js"
export * from "./NcbAgentsRemark.vue?vue&type=script&lang=js"
import style0 from "./NcbAgentsRemark.vue?vue&type=style&index=0&id=5517ac4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5517ac4a",
  null
  
)

export default component.exports